import { useTranslation } from 'react-i18next';
import NodeContent from '../NodeContent';
import { useEntity } from '../NodeContextProvider';

function TriggerNode() {
  const { t } = useTranslation(['icp-form-renderer']);

  const entityName = useEntity().name;

  return (
    <div className="icp-workflow-node trigger-node">
      <NodeContent
        id={0}
        name={`${t('workflow.trigger.prefix')}: ${entityName}`}
        icon="solar:pen-bold"
        disableDelete={true}
      />
    </div>
  );
}

export default TriggerNode;
